// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioPlayer_audio-player__raMvi {
  --seek-before-width: 0%;
  --buffered-width: 0%;
  width: 100%;
  border: 0.1rem solid var(--black-ten-opacity);
  border-radius: 1rem;
  padding: 2rem 4rem;
  display: flex;
  align-items: center;
}

.AudioPlayer_audio-player__play-btn__lXJGY {
  width: 4.6rem;
  height: 4.6rem;
}

.AudioPlayer_audio-player__current-time__D2Ios {
  color: var(--black-light);
  font-size: var(--text-base);
  font-weight: 700;
  margin-inline-end: 3.5rem;
}

/*|| slider  */
.AudioPlayer_audio-player__seek-slider__ckowm {
  flex-grow: 1;
  margin-inline-start: 2.2rem;
  position: relative;
  appearance: none;
}

/* || slider progress */
.AudioPlayer_audio-player__seek-slider__ckowm::before {
  position: absolute;
  left: 0;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  width: var(--seek-before-width);
  height: 0.4rem;
  background-color: var(--primary-color);
  cursor: pointer;
}

.AudioPlayer_audio-player__seek-slider__ckowm::-moz-range-progress {
  background-color: var(--primary-color);
}

.AudioPlayer_audio-player__seek-slider__ckowm::-ms-fill-lower {
  background-color: var(--primary-color);
}

/* || slider-track */

.AudioPlayer_audio-player__seek-slider__ckowm::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.4rem;
  cursor: pointer;
  background: linear-gradient(
    to right,
    var(--sky-dark) var(--buffered-width),
    var(--sky) var(--buffered-width)
  );
}

.AudioPlayer_audio-player__seek-slider__ckowm::-moz-range-track {
  width: 100%;
  height: 0.4rem;
  cursor: pointer;
  background: linear-gradient(
    to right,
    var(--sky-dark) var(--buffered-width),
    var(--sky) var(--buffered-width)
  );
}

.AudioPlayer_audio-player__seek-slider__ckowm::-ms-track {
  width: 100%;
  height: 0.4rem;
  cursor: pointer;
  background: transparent;
  border: solid transparent;
  color: transparent;
}

.AudioPlayer_audio-player__seek-slider__ckowm::-ms-fill-upper {
  background: linear-gradient(
    to right,
    var(--sky-dark) var(--buffered-width),
    var(--sky) var(--buffered-width)
  );
}

/* || slider thumb */

.AudioPlayer_audio-player__seek-slider__ckowm::-webkit-slider-thumb {
  position: relative;
  appearance: none;
  height: 1.5rem;
  width: 1.5rem;
  border: 1px solid var(--primary-color);
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  margin: -5px 0 0 0;
}

.AudioPlayer_audio-player__seek-slider__ckowm::-moz-range-thumb {
  border: 1px solid var(--primary-color);
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
}

.AudioPlayer_audio-player__seek-slider__ckowm::-ms-thumb {
  border: 1px solid var(--primary-color);
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
}

.AudioPlayer_audio-player__seek-slider__ckowm:active::-webkit-slider-thumb {
  transform: scale(1.2);
  background-color: var(--primary-color);
  border: none;
}

.AudioPlayer_audio-player__seek-slider__ckowm:active::-moz-range-thumb {
  transform: scale(1.2);
  background: var(--primary-color);
  border: none;
}

input[type="range"]:active::-ms-thumb {
  transform: scale(1.2);
  background: var(--primary-color);
  border: none;
}

/* || gloabl */
.AudioPlayer_audio-player__seek-slider__ckowm::-moz-focus-outer {
  border: 0;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .AudioPlayer_audio-player__raMvi {
    padding: 1rem 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AudioPlayer/AudioPlayer.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,+BAA+B;EAC/B,cAAc;EACd,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,oBAAoB;;AAEpB;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;;;;GAIC;AACH;;AAEA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,YAAY;AACd;;AAEA,cAAc;AACd;EACE,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".audio-player {\n  --seek-before-width: 0%;\n  --buffered-width: 0%;\n  width: 100%;\n  border: 0.1rem solid var(--black-ten-opacity);\n  border-radius: 1rem;\n  padding: 2rem 4rem;\n  display: flex;\n  align-items: center;\n}\n\n.audio-player__play-btn {\n  width: 4.6rem;\n  height: 4.6rem;\n}\n\n.audio-player__current-time {\n  color: var(--black-light);\n  font-size: var(--text-base);\n  font-weight: 700;\n  margin-inline-end: 3.5rem;\n}\n\n/*|| slider  */\n.audio-player__seek-slider {\n  flex-grow: 1;\n  margin-inline-start: 2.2rem;\n  position: relative;\n  appearance: none;\n}\n\n/* || slider progress */\n.audio-player__seek-slider::before {\n  position: absolute;\n  left: 0;\n  content: \"\";\n  top: 50%;\n  transform: translateY(-50%);\n  width: var(--seek-before-width);\n  height: 0.4rem;\n  background-color: var(--primary-color);\n  cursor: pointer;\n}\n\n.audio-player__seek-slider::-moz-range-progress {\n  background-color: var(--primary-color);\n}\n\n.audio-player__seek-slider::-ms-fill-lower {\n  background-color: var(--primary-color);\n}\n\n/* || slider-track */\n\n.audio-player__seek-slider::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.4rem;\n  cursor: pointer;\n  background: linear-gradient(\n    to right,\n    var(--sky-dark) var(--buffered-width),\n    var(--sky) var(--buffered-width)\n  );\n}\n\n.audio-player__seek-slider::-moz-range-track {\n  width: 100%;\n  height: 0.4rem;\n  cursor: pointer;\n  background: linear-gradient(\n    to right,\n    var(--sky-dark) var(--buffered-width),\n    var(--sky) var(--buffered-width)\n  );\n}\n\n.audio-player__seek-slider::-ms-track {\n  width: 100%;\n  height: 0.4rem;\n  cursor: pointer;\n  background: transparent;\n  border: solid transparent;\n  color: transparent;\n}\n\n.audio-player__seek-slider::-ms-fill-upper {\n  background: linear-gradient(\n    to right,\n    var(--sky-dark) var(--buffered-width),\n    var(--sky) var(--buffered-width)\n  );\n}\n\n/* || slider thumb */\n\n.audio-player__seek-slider::-webkit-slider-thumb {\n  position: relative;\n  appearance: none;\n  height: 1.5rem;\n  width: 1.5rem;\n  border: 1px solid var(--primary-color);\n  border-radius: 50%;\n  background-color: #fff;\n  cursor: pointer;\n  margin: -5px 0 0 0;\n}\n\n.audio-player__seek-slider::-moz-range-thumb {\n  border: 1px solid var(--primary-color);\n  height: 1.5rem;\n  width: 1.5rem;\n  border-radius: 50%;\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.audio-player__seek-slider::-ms-thumb {\n  border: 1px solid var(--primary-color);\n  height: 1.5rem;\n  width: 1.5rem;\n  border-radius: 50%;\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.audio-player__seek-slider:active::-webkit-slider-thumb {\n  transform: scale(1.2);\n  background-color: var(--primary-color);\n  border: none;\n}\n\n.audio-player__seek-slider:active::-moz-range-thumb {\n  transform: scale(1.2);\n  background: var(--primary-color);\n  border: none;\n}\n\ninput[type=\"range\"]:active::-ms-thumb {\n  transform: scale(1.2);\n  background: var(--primary-color);\n  border: none;\n}\n\n/* || gloabl */\n.audio-player__seek-slider::-moz-focus-outer {\n  border: 0;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .audio-player {\n    padding: 1rem 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"audio-player": `AudioPlayer_audio-player__raMvi`,
	"audio-player__play-btn": `AudioPlayer_audio-player__play-btn__lXJGY`,
	"audio-player__current-time": `AudioPlayer_audio-player__current-time__D2Ios`,
	"audio-player__seek-slider": `AudioPlayer_audio-player__seek-slider__ckowm`
};
export default ___CSS_LOADER_EXPORT___;
